const dataFormats = {
  id: "dataFormats",
  label: "Data Formats",
  endpoint: "data_formats",
  columnConfig: [
    {
      field: "name",
      headerName: "Data Format",
      width: 250,
      description: "Data Format",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default dataFormats;
